import { Menu as ChakraMenu, MenuProps as ChakraMenuProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

const propTypes = {
  isLazy: PropTypes.bool
};

const defaultProps = {
  isLazy: true
};

interface MenuPropTypes {
  isLazy: boolean;
}

export type MenuProps = ChakraMenuProps & MenuPropTypes;
export default function Menu(props: MenuProps): React.ReactElement {
  return <ChakraMenu {...props} />;
}

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;
Menu.displayName = DisplayNames.Menu;
